import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { StatusIconWrapper } from './StatusIcon.styles';
import { SequenceChangeType } from 'src/types/ViewModel/Stowage/Rotation/SequenceChangeType';

type Props = {
    hasChangedSequence?: SequenceChangeType;
};

const SequenceChangedIcon: React.FC<Props> = ({ hasChangedSequence }: Props) => {
    if (!hasChangedSequence) return <></>;
    return (
        <>
            <StatusIconWrapper title="Sequence manually rearranged">
                <span id="sequence-changed-marker">
                    <FontAwesomeIcon icon="circle" />
                </span>
            </StatusIconWrapper>
        </>
    );
};

export default SequenceChangedIcon;
